// Must match api-core's SHARED_AUTH_COOKIE_KEY. Local sets its own name, because dev sets the default on .alodev.org,
// which local hosts also receive.
export const SHARED_AUTH_COOKIE = process.env.SHARED_AUTH_COOKIE_KEY || 'aloware_shared_auth_token'
